/* Navigation only: product forms, customizer state and submission stay with their original components. */
(() => {
  const initialize = () => {
    const navigation = document.querySelector('[data-mobile-product-navigation]');
    const form = document.querySelector('form[data-product-form], form[data-photo-charm-form]');
    if (!navigation || !form || navigation.dataset.ready) return;
    navigation.dataset.ready = 'true';
    const mobile = matchMedia('(max-width: 749px)');
    const hasPersonalization = !!form.querySelector('[name^="properties["]');
    const hasOptions = !!form.querySelector('.pdp-option-group, .photo-charm-options');
    const target = hasPersonalization || hasOptions ? form : form.closest('.studio-product-info');
    const jump = navigation.querySelector('[data-mobile-product-jump]');
    navigation.querySelector('[data-mobile-product-label]').textContent = hasPersonalization ? navigation.dataset.personalizeLabel : hasOptions ? navigation.dataset.optionsLabel : navigation.dataset.detailsLabel;
    const price = document.querySelector('.studio-product-info .studio-product-price');
    const updatePrice = () => {
      if (!price) return;
      const copy = price.cloneNode(true);
      copy.querySelectorAll('.live-price-compare').forEach(element => element.remove());
      navigation.querySelector('[data-mobile-product-price]').textContent = copy.textContent.trim();
    };
    updatePrice();
    const priceObserver = new MutationObserver(updatePrice);
    if (price) priceObserver.observe(price, { childList: true, subtree: true, characterData: true });
    let scheduled = false;
    const update = () => {
      scheduled = false;
      const viewport = window.visualViewport;
      const keyboardOpen = viewport && innerHeight - viewport.height > 150;
      const editing = document.activeElement?.matches('input, textarea, select, [contenteditable="true"]');
      const consent = document.querySelector('#shopify-pc__banner');
      const blocked = document.body.matches('.cart-drawer-open, .market-panel-open, .eol-menu-open, .select-menu-open, .pdp-viewer-open, .ornament-viewer-open') || !!document.querySelector('dialog[open]') || !!consent?.getClientRects().length;
      const bounds = target.getBoundingClientRect();
      const formVisible = bounds.top < innerHeight - 90 && bounds.bottom > 80;
      const visible = mobile.matches && !keyboardOpen && !editing && !blocked && !formVisible;
      navigation.hidden = !visible;
      document.body.classList.toggle('mobile-product-navigation-visible', visible);
    };
    const schedule = () => {
      if (!scheduled) { scheduled = true; requestAnimationFrame(update); }
    };
    jump.addEventListener('click', () => {
      // Focus the form container, without opening the keyboard or changing any field.
      const previous = target.getAttribute('tabindex');
      target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
      window.scrollTo({ top: window.scrollY + target.getBoundingClientRect().top - 20, behavior: 'instant' });
      target.addEventListener('blur', () => {
        if (previous === null) target.removeAttribute('tabindex');
        else target.setAttribute('tabindex', previous);
      }, { once: true });
      schedule();
    });
    addEventListener('scroll', schedule, { passive: true });
    addEventListener('resize', schedule, { passive: true });
    document.addEventListener('load', schedule, true);
    document.addEventListener('focusin', schedule);
    document.addEventListener('focusout', schedule);
    document.addEventListener('toggle', schedule, true);
    document.addEventListener('visitorConsentCollected', schedule);
    window.visualViewport?.addEventListener('resize', schedule, { passive: true });
    mobile.addEventListener('change', schedule);
    const bodyObserver = new MutationObserver(schedule);
    bodyObserver.observe(document.body, { attributes: true, attributeFilter: ['class'], childList: true });
    const layoutObserver = new ResizeObserver(schedule);
    layoutObserver.observe(target);
    layoutObserver.observe(form.closest('.studio-product-page') || form);
    new IntersectionObserver(schedule, {rootMargin:'-80px 0px -90px 0px'}).observe(target);
    update();
  };
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
